import tour1 from '../images/tour-1.jpeg';
import tour2 from '../images/tour-2.jpeg';
import tour3 from '../images/tour-3.jpeg';
import tour4 from '../images/tour-4.jpeg';
export const pageLinks = [
  { id: 1, href: '#home', text: 'home' },
  { id: 2, href: '#about', text: 'about' },
  { id: 3, href: '#services', text: 'services' },
  { id: 4, href: '#tours', text: 'tours' },
];

export const socialLinks = [
  { id: 1, href: 'https://www.twitter.com', icon: 'fab fa-facebook' },
  { id: 2, href: 'https://www.twitter.com', icon: 'fab fa-twitter' },
  { id: 3, href: 'https://www.twitter.com', icon: 'fab fa-squarespace' },
];

export const Service = [
  {
    id: 1,
    icon: 'fas fa-wallet fa-fw',
    text: ' Lorem ipsum dolor sit amet consectetur adipisicing elit.Asperiores, officia.',
    title: 'saving money',
  },
  {
    id: 2,
    icon: 'fas fa-tree fa-fw',
    text: ' Lorem ipsum dolor sit amet consectetur adipisicing elit.Asperiores, officia.',
    title: 'endless hiking',
  },
  {
    id: 3,
    icon: 'fas fa-socks fa-fw',
    text: ' Lorem ipsum dolor sit amet consectetur adipisicing elit.Asperiores, officia.',
    title: 'amazing comfort',
  },
  {
    id: 4,
    icon: 'fas fa-wallet fa-fw',
    text: ' Lorem ipsum dolor sit amet consectetur adipisicing elit.Asperiores, officia.',
    title: 'saving money',
  },
  {
    id: 5,
    icon: 'fas fa-wallet fa-fw',
    text: ' Lorem ipsum dolor sit amet consectetur adipisicing elit.Asperiores, officia.',
    title: 'saving money',
  },
];

export const tours = [
  {
    id: 1,
    image: tour1,
    title: 'Tibet Adventure',
    date: 'august 26th, 2020',
    info: ' Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumquevitae tempore voluptatum maxime reprehenderit eum quodexercitationem fugit, qui corporis.',
    location: 'china',
    duration: 6,
    cost: '2100',
  },
  {
    id: 2,
    image: tour2,
    title: 'best of java',
    date: 'october 1th, 2020',
    info: ' Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumquevitae tempore voluptatum maxime reprehenderit eum quodexercitationem fugit, qui corporis.',
    location: 'indonesia',
    duration: 11,
    cost: '1400',
  },
  {
    id: 3,
    image: tour3,
    title: '',
    date: 'september 15th, 2020',
    info: ' Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumquevitae tempore voluptatum maxime reprehenderit eum quodexercitationem fugit, qui corporis.',
    location: 'china',
    duration: 6,
    cost: '2100',
  },
  {
    id: 4,
    image: tour4,
    title: 'Tibet Adventure',
    date: 'august 26th, 2020',
    info: ' Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cumquevitae tempore voluptatum maxime reprehenderit eum quodexercitationem fugit, qui corporis.',
    location: 'china',
    duration: 6,
    cost: '2100',
  },
];
